import React from "react";

const Result = ({
  req,
  index,
  data,
  avatar,
  weigh,
  handleShowEvacuation2,
  safeAddAndFormat,
  setModalInfo
}) => {
  return (
    <div key={index}>
      <h6 className="py-2 ml-1" style={{fontSize: "14px"}}>{req}</h6>
      {data.map((datum, index) => {
        return (
          <div key={index}>
            <div className="reqBg">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div className="d-flex align-items-center ">
                    <img src={avatar} alt={avatar} />
                    <p className="mb-0 ml-2">{`${
                      datum?.center?.name
                    }`}</p>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div>
                    <img src={weigh} alt="weight" />
                  </div>
                  <div>
                    <p
                      className="mb-0"
                      style={{
                        fontWeight: "bold",
                        color: "#c4da00",
                        marginLeft: "5px",
                      }}
                    >
                      {`${safeAddAndFormat(
                        datum?.nylon_kg,
                        datum?.pet_plastic_kg
                      )}`}
                    </p>
                  </div>
                </div>

                <div className="addShow">
                  <p className="mb-0 mx-3 text-capitalize">
                    {`${
                      datum?.center?.address
                    }`}
                  </p>
                </div>

                <div className="d-flex align-items-center">
                  <div className="addShow">
                    <p className="mb-0 mx-3 text-capitalize">
                      {`${
                        datum?.center?.phone
                      }`}
                    </p>
                  </div>
                  <div className="ml-4">
                    <div
                      className="buttonLike cursor-pointer"
                      style={{ cursor: "pointer" }}
                    >
                      <span
                        style={{
                          color: "#fff",
                          textAlign: "center",
                          margin: "auto",
                        }}
                        onClick={() => {
                          setModalInfo(datum)
                          handleShowEvacuation2();
                        }}
                      >
                        &#62;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Result;
